<template>
  <div class="address">
    <span> {{ addressFirstLine }}</span>
    <span v-if="addressSecondLine">{{ addressSecondLine }}</span>
    <span>{{ address.city }}, {{ address.province_abbr }}</span>
    <span>{{ address.postal_code }}</span>
  </div>
</template>

<script>
export default {
  name: 'AddressDisplay',
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  computed: {
    addressFirstLine() {
      return this.address.line1 || this.address.address_line1;
    },

    addressSecondLine() {
      return this.address.line2 || this.address.address_line2;
    }
  }
};
</script>

<style scoped lang="scss">
.address {
  display: flex;
  flex-direction: column;
}
</style>
